<template>
  <div v-if="homeData" class="swiper-container CompanyCard w margin">
    <div class="swiper-wrapper">
      <div
        v-for="(card, index) in homeData.special_units"
        :key="index"
        class="swiper-slide"
      >
        <div class="card">
          <div class="card__img">
            <img :src="card.image" :alt="card.title" />
          </div>

          <div v-if="card.logo" class="card__companylogo">
            <img :src="card.logo" :alt="card.title" />
          </div>

          <h3 class="card__title">{{ card.title }}</h3>

          <div class="card__desc drRtl">
            <p class="card__address" v-if="card.addresses.length > 0">
              <LocationIcon /> {{ card.addresses[0].address }}
            </p>
            <span class="card__tel" v-if="card.addresses.length > 0">
              <Callicon /> {{ card.addresses[0].phones }}
            </span>
          </div>

          <div class="card__btn">
            <router-link
              v-if="$root.globalData"
              :to="`/unit/${card.id}/${slugGenerator(card.title)}`"
              class="card_link"
              >{{ $root.globalData.keys.industry_unit_button }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import CardImg from "../../assets/images/factory2.jpg";
import Swiper from "swiper/swiper-bundle.min";

import Callicon from "../svgs/Callicon.vue";
import LocationIcon from "../svgs/LocationIcon.vue";
import Callicon1 from "../svgs/Callicon.vue";
let breakpoints = {
  300: {
    slidesPerView: 1,
    spaceBetween: 40,
    centeredSlides: true,
  },
  370: {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: true,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 1,
  },
  1200: {
    slidesPerView: 4,
    spaceBetween: 10,
  },
};
export default {
  components: {
    Callicon,
    LocationIcon,
    Callicon1,
  },

  data() {
    return {
      slider: null,

      cards: {
        cardCount: 10,
        cardimg: CardImg,
        cardtitle: "لبنیات کاله",
        cardadress:
          " تهران، خیابان جمهوری، خیابان ۱۲ فروردین نبش تقاطع خیابان آذربایجان، پلاک ۱۳۶ ",
        cardtel: "۰۲۱-۶۶۴۵۴۵۱۱ , ۰۲۱-۶۱۱۲۳۶۴",
        cardlink: "مشاهده شرکت",
      },
    };
  },
  mounted() {
    this.initSlider(false);
  },
  methods: {
    initSlider(kill = false) {
      this.$root.initSwiper("recommendedProductSlider", kill, () => {
        try {
          if (this.slider) {
            this.slider.destroy();
          }
        } catch (e) {}
        this.slider = new Swiper(".CompanyCard.swiper-container", {
          spaceBetween: 1,
          //   centeredSlides: true,
          loop: false,
          speed: 500,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          autoplay: true,

          breakpoints,
        });
      });
    },
    slugGenerator(name) {
      if (name == null) return name;
      let result = " ";
      result = name.replace(/ /g, "-");
      return result;
    },
  },
  computed: {
    homeData() {
      return this.$store.getters.getHomeData;
    },
  },
  watch: {
    homeData() {
      this.initSlider(true);
    },
  },
};
</script>

<style scoped>
.card {
  width: 300px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  text-align: right;
  position: relative;
}
.swiper-slide {
  margin: 0 10px;
}
.card__companylogo {
  width: 85px;
  height: 85px;
  border-radius: 85px;
  background-color: #fff;
  position: absolute;
  left: 10px;
  top: 150px;
  box-shadow: 0 10px 10px #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card__companylogo img {
  width: 80%;
}
.card__img img {
  width: 100%;
  height: 200px;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.card__title {
  padding: 10px;
}
.card__desc {
}
.card__address {
height: 100px !important;
}
.card__address,
.card__tel {
  font-size: 14px;
  color: #666;
  padding: 10px;
  display: flex;
    height: max-content;
}
.card__tel {
  font-size: 13px;
}

.card__btn {
  width: 100%;
  text-align: center;
  margin: 1rem 0;
}

.card_link {
  padding: 7px 20px;
  width: 70%;
  border-radius: 5px;
  background-color: #0d6efd;
  color: #fff;
  font-size: 13px;
  box-shadow: 0 0 10px #0d6efd;
  cursor: pointer;
  border: 2px solid #0d6efd;
  transition: all ease 0.5s;
}
.card_link:hover {
  background-color: #fff;
  color: #0d6efd;
  box-shadow: none;
}
</style>
<style>
.CompanyCard {
  width: 90% !important;
  position: relative;
}
.CompanyCard .slick-dots li button:before {
  color: white;
  opacity: 1;
  font-size: 10px;
}
.CompanyCard .slick-dots li.slick-active button:before {
  opacity: 1;
  color: #fb9d00;
  font-size: 14px;
}
</style>
